import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { GetShortCode } from 'services/openapiClient';

const ShortUrlPage: React.FC = () => {
  const { shortCode } = useParams<{ shortCode: string }>();
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const code = await GetShortCode(shortCode);
        if (code && code.originalPath) {
          window.location.href = code.originalPath;
        }
      } catch (error) {
        console.error('Error during token validation', error);
        window.location.href = '/404';
      }
    };

    fetchData();
  }, [shortCode, history]);

  return <div>Loading...</div>;
};

export default ShortUrlPage;
